export interface ImageProps {
  src: string;
  alt: string;
  maxWidth?: number;
}

export const Image = ({ src, alt, maxWidth }: ImageProps) => {
  return (
    <img
      src={src}
      alt={alt}
      style={{ margin: "0 auto", ...(maxWidth ? { maxWidth } : {}) }}
    />
  );
};
